require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-project-household-natural-gas-connections.json") })
        }
      }, "path---es-mx-project-household-natural-gas-connections");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-project-household-natural-gas-connections!./.cache/json/es-mx-project-household-natural-gas-connections.json
// module id = 897
// module chunks = 231608221292675